<ion-header>
  <ion-toolbar color="primary">
    <ion-title class="ion-text-center">NextGen Rodeo</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-card class="ion-text-center">
    <ion-card-content>
      <div style="display: flex; justify-content: center;">
        <ng-lottie 
          [options]="{
            path: 'assets/animations/success.animation.json'
          }" 
          [styles]="{height: '200px', width: '200px'}"
          (animationCreated)="animationCreated($event)"
          (enterFrame)="onEnterFrame($event)">
        </ng-lottie>
      </div>
      <ion-label style="font-weight: bold; color: black;">{{message}}</ion-label>
      <br/>
      <ion-label style="font-weight: normal; color: black;" >You may close this page.</ion-label>
    </ion-card-content>
  </ion-card>
</ion-content>